import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import CustomBreadcrumb from 'components/base/CustomBreadcrumb';
import CustomListComponent from 'components/base/CustomListComponent';
import { createAction } from 'utils';
import ContentSections from 'components/base/ContentSections';
import { APIStatus, LanguageConfig, hideLevelDiscount } from 'config/CustomEnums';
import Loading from 'components/base/Loading';
import AuthButton from 'components/base/AuthButton';
import { PermissionCodes } from 'config/PermissionCodes';
import MembershipInfoCard from 'components/customer/MembershipInfoCard';
import { listItem } from 'components/banners/DisplayItems';
import i18n from '../../../I18n';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import CustomRichTextViewer from 'components/base/CustomRichTextViewer';

function LevelDiscountDetail({
  languages,
  levelDiscount,
  status,
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();

  const renderTabForLanguage = (language) => {
    const isEnglish = language === LanguageConfig.english;

    return [
      <>
        <div className="first-section-title">
          INFORMATION
        </div>
        {listItem('Name', levelDiscount.sourceName)}
        {
          hideLevelDiscount
            ? null
            : <>
              {listItem('Discount', levelDiscount.displayDiscount)}
              {listItem('Shopify - free delivery', levelDiscount.displayShopifyFreeDelivery)}
            </>
        }
      </>,
      <>
        <div className="first-section-title">
          {i18n.t('levelBenefits', { locale: language })}
        </div>
        {
          levelDiscount?.levelBenefits?.map((item, index) => (
            <>
              <CustomTitleLabel title={`# ${index + 1}`} />
              {listItem('title', item?.translations?.[language]?.title)}
              <CustomTitleLabel title="content" />
              <CustomRichTextViewer initialValue={item?.translations?.[language]?.content || '-'} />
              {
                isEnglish
                  ? listItem('Highlight for this level', item.highlight ? 'true' : 'false')
                  : null
              }
            </>
          ))
        }
      </>,
      <>
        <div className="first-section-title">
          GENERAL
        </div>
        {listItem('Creation time', levelDiscount.detailDisplayCreationDate)}
        {listItem('Last modified time', levelDiscount.detailDisplayLastModifiedTime)}
        {listItem('Last modified by', levelDiscount.displayLastModifiedBy)}
      </>
    ]
  };


  const tabs = [
    {
      name: 'Detail',
      content: (
        status === APIStatus.calling
          ? <Loading />
          : <ContentSections
            languageTabContent={{
              containers: languages?.map((item) => ({
                container: renderTabForLanguage(item.code),
                key: item.code,
                title: item.sourceName,
              })),
            }}
            hidePreview
          />
      ),
    },
  ];

  const buttons = [
    <AuthButton
      title="Edit"
      action={() => {
        dispatch({ type: 'levelDiscount/clearData' });
        history.push({
          pathname: 'edit/',
        });
      }}
      requires={PermissionCodes.changeLanguage}
    />,
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].name);

  useEffect(() => {
    if (params.id) {
      dispatch(
        createAction('levelDiscount/getOneDetail')({
          id: params.id,
          view: true,
        }),
      );
    }
    dispatch({
      type: 'language/getList',
      payload: {
        isSelectorLoad: true,
      }
    });
    return () => {
      dispatch({ type: 'levelDiscount/clearData' });
    };
  }, [dispatch, params.id]);

  return (
    <div className="campaign-category-detail">
      <CustomListComponent
        caution={{
          detail: '',
          title: levelDiscount.sourceName,
        }}
        defaultActiveKey={activeTab}
        breadcrumb={<CustomBreadcrumb name={levelDiscount.sourceName} />}
        buttons={buttons}
        tabs={tabs}
        onTabChange={(key) => {
          setActiveTab(key);
        }}
      />
    </div>
  );
}

const mapPropsToState = (state) => ({
  languages: state.language.allList,
  levelDiscount: state.levelDiscount.detail,
  status: state.loading.status,
})

export default connect(mapPropsToState)(LevelDiscountDetail)